import { useGet } from '../../HttpClient';
import { RateModel } from '@app/models';
import { referenceDataBaseUrl } from '../BaseUrls';
import { useQueryWithErrorHandling } from '../../../hooks/UseQueryWithErrorHandling';
import { useQueryClient } from '@tanstack/react-query';

const pillarCode = "tms";
 
export function useBankOfEnglandBaseRates() {
  const get = useGet(true, pillarCode);
  const getBankOfEnglandBaseRates = (): Promise<RateModel[]> => get(`${referenceDataBaseUrl}/rate-types/BOE/rates`);
  return useQueryWithErrorHandling({
    queryKey: ['get-bank-of-england-base-rates'],
    queryFn: async () => await getBankOfEnglandBaseRates(),
  });
}

export function useRefreshBankOfEnglandBaseRates() {
  const queryClient = useQueryClient();
  return async () => {
    await queryClient.invalidateQueries({ queryKey: ['get-bank-of-england-base-rates'] });
  };
}
